import { Component } from '@angular/core';
import { DialogRef } from '../../services/modal.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';

export class StatusModalContext {
  title: string;
  messages: { text: string; isError: boolean }[];
}

@Component({
  standalone: true,
  selector: 'custom-status-modal',
  templateUrl: 'custom-status-modal.component.html',
  imports: [TranslatePipe, CommonModule],
})
export class CustomStatusModalComponent {
  context: StatusModalContext;

  constructor(public dialog: DialogRef<StatusModalContext>) {
    this.context = dialog.context;
  }

  close(): void {
    this.dialog.close();
  }
}
